import { PlaceActionType } from './place-action-type';
import { castArray } from 'lodash';

export interface LoadPlaceErrorAction {
  errors: Error[];
  placeKey: string;
  type: PlaceActionType.LoadPlaceError;
}

export const loadPlaceError = (
  placeKey: string,
  errors: Error | readonly Error[],
): LoadPlaceErrorAction => ({
  errors: castArray(errors),
  placeKey,
  type: PlaceActionType.LoadPlaceError,
});
